import { createTheme } from '@material-ui/core/styles';

export const createTheme2 = createTheme